import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e912758"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-arrow-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_2 = { id: "form-training-put" }
const _hoisted_3 = { class: "card background_1 p-4 d-flex flex-column justify-content-between" }
const _hoisted_4 = { class: "row g-4 p-4" }
const _hoisted_5 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "*", -1))
const _hoisted_7 = { class: "col-sm-12 col-xl-9" }
const _hoisted_8 = {
  for: "form-training-put-title",
  class: "form-label cor_texto_1"
}
const _hoisted_9 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { class: "col-sm-4 col-md-5 col-lg-4 col-xl-3" }
const _hoisted_12 = {
  for: "form-training-put-score",
  class: "form-label cor_texto_1"
}
const _hoisted_13 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_14 = {
  id: "form-training-post-fields-description-date",
  class: "col-sm-12 col-xl-12"
}
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-sm-12 col-xl-12" }
const _hoisted_17 = {
  for: "form-training-post-description",
  class: "form-label cor_texto_1"
}
const _hoisted_18 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-sm-12 col-xl-4" }
const _hoisted_22 = {
  for: "form-training-post-date",
  class: "form-label cor_texto_1"
}
const _hoisted_23 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_24 = {
  id: "form-training-post-date",
  class: "row g-4"
}
const _hoisted_25 = { class: "col-sm-12 col-xl-12" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn background_btn_1",
  style: {"color":"var(--cor_icones_1)","margin-top":"1rem"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-save",
    style: {"color":"var(--cor_icones_1)"},
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createTextVNode(" Salvar ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CampHeader = _resolveComponent("CampHeader")!
  const _component_MediaSystemEngine = _resolveComponent("MediaSystemEngine")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_CampFormRackSubmitBtn = _resolveComponent("CampFormRackSubmitBtn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitForm && _ctx.onSubmitForm(...args)), ["prevent"]))
      }, [
        _createVNode(_component_CampHeader, null, {
          title: _withCtx(() => [
            _createTextVNode("Editar Prêmio")
          ]),
          button: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: `/catalogo-de-premios`,
              class: "btn btn_background_1"
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createTextVNode(" Voltar ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("fieldset", _hoisted_3, [
            _createVNode(_component_MediaSystemEngine, {
              updateMode: true,
              mediaFile: _ctx.mediaFile,
              "onGet:UpdatedMediaFile": _ctx.handleUpdatedMediaFile
            }, null, 8, ["mediaFile", "onGet:UpdatedMediaFile"])
          ]),
          _createElementVNode("fieldset", {
            class: "card background_1",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetWarning && _ctx.resetWarning(...args)))
          }, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.isRequiredField)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createTextVNode(" Campos obrigatórios "),
                    _hoisted_6
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, [
                  _createTextVNode("Título: "),
                  (_ctx.isRequiredField)
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_9, "*"))
                    : _createCommentVNode("", true),
                  (_ctx.formModel.title.length)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        style: _normalizeStyle(`color: ${_ctx.infoMaxCharactersTitle ? 'var(--cor_indicadores_4)' : 'var(--cor_texto_2)'}`)
                      }, _toDisplayString(_ctx.infoMaxCharactersTitle ? _ctx.infoMaxCharactersTitle : _ctx.infoMaxTitle), 5))
                    : _createCommentVNode("", true),
                  _hoisted_10
                ]),
                _createVNode(_component_el_input, {
                  placeholder: "Treinamento...",
                  modelValue: _ctx.formModel.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formModel.title) = $event)),
                  clearable: "",
                  type: "text",
                  name: "form-training-put-title",
                  id: "form-training-put-title"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, [
                  _createTextVNode("Pontuação: "),
                  (_ctx.isRequiredField)
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_13, "*"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formModel.points,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formModel.points) = $event)),
                  type: "number",
                  name: "form-training-put-score",
                  id: "form-training-put-score",
                  min: 0
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, [
                      _createTextVNode("Descrição: "),
                      (_ctx.isRequiredField)
                        ? (_openBlock(), _createElementBlock("strong", _hoisted_18, "*"))
                        : _createCommentVNode("", true),
                      (_ctx.formModel.description.length)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            style: _normalizeStyle(`color: ${_ctx.infoMaxCharactersWarning ? 'var(--cor_indicadores_4)' : 'var(--cor_texto_2)'}`)
                          }, _toDisplayString(_ctx.infoMaxCharactersWarning ? _ctx.infoMaxCharactersWarning : _ctx.infoMaxCharacters), 5))
                        : _createCommentVNode("", true),
                      _hoisted_19
                    ]),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formModel.description,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formModel.description) = $event)),
                      clearable: "",
                      type: "textarea",
                      placeholder: "Digite...",
                      name: "form-training-post-description",
                      id: "form-training-post-description"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", _hoisted_22, [
                      _createTextVNode("Data de expiração: "),
                      (_ctx.isRequiredField)
                        ? (_openBlock(), _createElementBlock("strong", _hoisted_23, "*"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.formModel.expiration_date,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formModel.expiration_date) = $event)),
                          type: "datetime",
                          placeholder: "Selecione data de término",
                          format: "DD/MM/YYYY HH:mm:ss",
                          "default-time": _ctx.moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
                          "disabled-date": _ctx.handleDisabledDateMin,
                          clearable: false
                        }, null, 8, ["modelValue", "default-time", "disabled-date"])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_CampFormRackSubmitBtn, { class: "pe-2" }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          })
        ])
      ], 32)
    ])
  ]))
}